/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    GetRedirectionUrlResponse,
} from '../models';

export interface ZendeskAuthApiControllerGetRedirectionUrlRequest {
    returnTo?: any;
}

/**
 * 
 */
export class AuthApi extends runtime.BaseAPI {

    /**
     */
    async zendeskAuthApiControllerGetRedirectionUrlRaw(requestParameters: ZendeskAuthApiControllerGetRedirectionUrlRequest): Promise<runtime.ApiResponse<GetRedirectionUrlResponse>> {
        const queryParameters: any = {};

        if (requestParameters.returnTo !== undefined) {
            queryParameters['return_to'] = requestParameters.returnTo;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/zendesk/get-auth`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async zendeskAuthApiControllerGetRedirectionUrl(requestParameters: ZendeskAuthApiControllerGetRedirectionUrlRequest): Promise<GetRedirectionUrlResponse> {
        const response = await this.zendeskAuthApiControllerGetRedirectionUrlRaw(requestParameters);
        return await response.value();
    }

}
